import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { SearchService } from '../search.service';
import { ThemeService } from '../theme.service';
import { BaseComponent } from './BaseComponent';
import { Global } from './Global';

@Directive({
  selector: '[appBaseSearchComponent]'
})
export class BaseSearchComponent extends BaseComponent {

    @Input() selectedItemType;
    @Input() activateSuggestions: boolean = true;
    @Output() onSearchClicked = new EventEmitter();
    @Input() query = "";

    inputValue = "";

    suggestions = [];
    lastSuggestionQuery: string;
    inputTimeout: any = null;
    showSuggestions: boolean = true;

    constructor(protected themeService: ThemeService, protected searchService: SearchService) {
        super();
    }

    searchClick() {

        this.showSuggestions = false;
        this.query = this.inputValue;

        this.onSearchClicked.emit({ query: this.query, itemType: this.selectedItemType });

        if((<any>window).gtag) {
            (<any>window).gtag('event', this.query, {
            'event_category': 'Search',
            'event_label': this.selectedItemType
            });
        }
      if ((<any>window)._paq) {
        (<any>window)._paq.push(['trackEvent', "Search", this.query, this.selectedItemType]);
      }
    }

    onFocus() {
        this.showSuggestions = true;
    }

    onKeyUp(e) {
        this.showSuggestions = true;
        this.inputValue = e.target.value;

        if (this.inputTimeout) {
            clearTimeout(this.inputTimeout);
        }

        this.inputTimeout = setTimeout(() => {
            if (this.lastSuggestionQuery != this.inputValue) {
                console.log(this.lastSuggestionQuery, this.inputValue);
                this.getSuggestions();
            }
        }, 300);

        if (e.keyCode === 13) { //Enter
            this.searchClick();
        }
    }

    getSuggestions() {

        if (this.activateSuggestions) {
            const query = this.inputValue || "";
            if (query.length >= 2) {
                this.lastSuggestionQuery = query;
                this.searchService.getSuggestions(Global.getStore(), this.selectedItemType, Global.getCountry(), query.trim(), 0, 20).subscribe(res => {

                    if (res && res["results"] && res["results"]["results"] instanceof Array) {
                        this.suggestions = res["results"]["results"];
                    }
                    else {
                        this.suggestions = [];
                    }

                }, err => {

                });
            }
            else {
                this.suggestions = [];
            }
        }

    }

    isDarkTheme(): boolean {
        return this.themeService.isDarkTheme();
    }

    getSearchAlt(): string {
        return this.getString('findDeals');
    }

}
